<template>
    <!-- 精彩瞬间 -->
    <div class="read-box">
        <div :class="['title', isEn ? 'title-en' : '']">
            <img
                :src="isEn ? 'https://i.gsxcdn.com/2713932568_3sf01gvu.png' : 'https://i.gsxcdn.com/2713924662_q6lgjm8o.png'"
                class="left"
                alt=""
            >
            精彩瞬间
            <img
                :src="isEn ? 'https://i.gsxcdn.com/2713932885_1szsr8vr.png' : 'https://i.gsxcdn.com/2713931059_scywje61.png'"
                class="right"
                alt=""
            >
        </div>
        <Myvideo
            ref="myvideo"
            :tag-index="333333336666633"
            :page-data="wonderfulMomentData"
            :loop="false"
            :show-shadow="false"
            play-img="https://i.gsxcdn.com/2274080577_ggn54um8.png"
            style="position: absolute;
            left: 50%;
            transform: translateX(-50%);
            border-radius: .43rem;
            width: 8.08rem;
            height: 6.05rem;"
            @gioreport="gioreport"
            @stop-other="stopOther"
            @videoended="handleVideoEnded"
        />
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import Myvideo from '@/components/Myvideo.vue';

@Options({
    components: {
        Myvideo
    },
    created() {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {
                    wonderfulMomentInfo: {
                        // 精彩瞬间图片
                        wonderfulImage: '',
                        // 精彩瞬间视频
                        wonderfulMomentUrl: '',
                    },
                };
            }
        },
        isEn: {
            type: Boolean,
            default() {
                return false;
            }
        },
    },
    computed: {
        wonderfulMomentData() {
            const {wonderfulImage, wonderfulMomentUrl} = this.pageData.wonderfulMomentInfo;
            return {
                opusVideoMix: wonderfulMomentUrl,
                // opusVideoMix: 'https://i.gsxcdn.com/feihua/20241029/qbkK_1730170569.mp4',
                courseCover: wonderfulImage
            };
        }
    }
})
export default class ReadAloud extends Vue {

    gioreport() {

    }

    // 点击播放视频时触发
    stopOther() {
        this.$emit('stop-other');
        console.log('埋点上报播放视频', this.pageData.courseName);
    }

    // 视频播放完成时触发
    handleVideoEnded() {
        console.log('埋点上报视频播放完成', this.pageData.courseName);
    }
}
</script>

<style lang="scss" scoped>
.read-box {
    width: 8.08rem;
    min-height: 7rem;
    position: relative;
    margin-bottom: .46rem;

    .title {
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FC980F;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: .56rem;
        margin-bottom: .43rem;

        .left {
            margin-right: .24rem;
            width: .96rem;
            height: .19rem;
        }

        .right {
            margin-left: .24rem;
            width: .96rem;
            height: .19rem;
        }
    }

    .title-en {
        color: #07C763;
    }
}
</style>
